import { formatTimeDisplay, calculateDurationMinutes } from 'lib/timeHelpers';

const CardPlaySchedule = ({ item }) => {
  const goToBuy = () => {
    console.log('detail', item.id);
    // Bisa arahkan ke detail page: navigate(`/play/${item.id}`)
  };

  // Format waktu mulai & selesai
  const startTimeFormatted = formatTimeDisplay(item.start_time);
  const endTimeFormatted = formatTimeDisplay(item.end_time);

  // Hitung durasi
  const durationMinutes = calculateDurationMinutes(
    item.start_time,
    item.end_time,
    null, // tidak ada fallback karena play session tidak punya class.duration
  );

  return (
    <div className="flex flex-row items-center gap-2">
      {/* Desktop: jam mulai - selesai */}
      <div className="hidden md:block font-bold text-kin-text text-base max-w-[120px]">
        {`${startTimeFormatted} - ${endTimeFormatted}`}
      </div>

      {/* Card utama */}
      <div className="bg-white flex flex-col items-start md:flex-row md:items-center justify-between font-semibold text-kin-text rounded-xl p-4 md:py-4 md:px-6 flex-1 gap-2">
        {/* Mobile: jam mulai - selesai */}
        <div className="block md:hidden font-bold text-kin-text text-base">
          {`${startTimeFormatted} - ${endTimeFormatted}`}
        </div>

        {/* Info utama */}
        <div className="flex flex-col">
          {/* Durasi */}
          <span className="hidden md:block text-sm font-light">{durationMinutes}</span>
          {/* Judul Play */}
          <span className="text-lg font-bold">{item.exhibition_play?.title || 'Play Session'}</span>
          {/* Durasi untuk mobile */}
          <span className="block md:hidden text-xs font-light">{durationMinutes}</span>

          {/* Kuota (optional) */}
          <span className="text-xs font-light">{item.remaining_quota} seats available</span>
        </div>

        {/* Tombol Buy */}
        {/* <button
          onClick={() => goToBuy(item.id)}
          className="w-full md:w-fit bg-primary-main text-white rounded-[100px] py-2 px-3 flex justify-center items-center">
          <span className="text-xs font-semibold block">BUY NOW</span>
        </button> */}

        {/* {type === 'cart' ? (
          <button
            onClick={() => console.log('item')}
            className="w-full md:w-fit bg-primary-main text-white rounded-[100px] py-2 px-3 flex justify-center items-center">
            <span className="text-xs font-semibold block">ADD TO CART</span>
          </button>
        ) : (
          <button
            onClick={() => goToBuy(item.id)}
            className="w-full md:w-fit bg-primary-main text-white rounded-[100px] py-2 px-3 flex justify-center items-center">
            <span className="text-xs font-semibold block">BUY NOW</span>
          </button>
        )} */}
      </div>
    </div>
  );
};

export default CardPlaySchedule;
